import React from 'react'

const UpdateUser = () => {
  return (
    <form action="https://pos.freelance.in.th/api/login.php" method="POST"  target="_blank" 
        id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
      >
        <label for="email">email:</label><br />
        <input type="email" id="email" name="email"  /><br />
        <label for="password">password</label><br />
        <input type="password" id="password" name="password"  /><br />
        <label for="mode">Mode:</label><br />
        <input type="text" id="mode" name="mode" value="update" /> <br /><br />
        <input type="submit" value="Submit" />
    </form>
  )
}

export default UpdateUser